import React from "react";
import { Table } from "reactstrap";
import { TableProps } from "./type";
import "../../styles/table.scss";
import Button from "../Button";

const TableExtend = ({
  responsive,
  tableData,
  striped,
  tableMapping,
  onFilter,
  onRowClick,
  extraRow = [],
  onHeadClick = () => {},
}: TableProps) => {
  const renderRow = (row: any, index: number) => (
    <tr
      key={row?.id || index}
      className={onRowClick ? "normal-button" : ""}
      onClick={() => onRowClick?.(row)}
    >
      {tableMapping
        .filter((tb) => tb.isActive)
        .map((tb) => {
          if (tb.customComponent)
            return (
              <td key={`${tb?.id || index}-${tb.label}`}>
                {tb.customComponent(row)}
              </td>
            );
          let val: any = row;
          tb.mappingKeys.forEach((k) => {
            if (val) {
              val = val[k];
            } else {
              val = tb.defaultVal || "";
            }
          });
          return <td key={`${tb?.id || index}-${tb.label}`}>{val}</td>;
        })}
    </tr>
  );
  return (
    <Table responsive={responsive} striped={striped}>
      <thead>
        {extraRow.length > 0 && (
          <tr className="extra-row">
            {extraRow.map((er) => (
              <th className="extra-th" colSpan={er.colSpan} key={er.id}>
                {er.label}
              </th>
            ))}
          </tr>
        )}
        <tr>
          {tableMapping
            .filter((tb) => tb.isActive)
            .map((tb, index) => {
              const showFilter = tb.isFiltered != null;
              const handleClick = () => {
                if (!showFilter) return;
                onFilter?.(index, !tb.isFiltered);
              };
              if (tb.renderAsButton) {
                return (
                  <th key={tb.id} style={{ minWidth: 200 }}>
                    <Button
                      onClick={() => onHeadClick(tb)}
                      label={tb.label}
                      type="primary"
                      outline
                      size="small"
                    />
                  </th>
                );
              }
              return (
                <th key={tb.id}>
                  <div
                    className={`table-header ${
                      showFilter ? "normal-button" : ""
                    }`}
                    onClick={handleClick}
                  >
                    <span>{tb.label}</span>
                    {showFilter && (
                      <i className="material-icons icon">
                        {tb.isFiltered ? "north" : "south"}
                      </i>
                    )}
                  </div>
                </th>
              );
            })}
        </tr>
      </thead>
      <tbody>{tableData?.map?.(renderRow)}</tbody>
    </Table>
  );
};

export default TableExtend;
